var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMicOff = function SvgMicOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33273 6.27646L0.861328 1.80506L1.80414 0.862251L15.1375 14.1956L14.1947 15.1384L11.2698 12.2136C10.5321 12.787 9.63987 13.171 8.66606 13.2924V14.0003H10.6661V15.3337H5.33273V14.0003H7.33273V13.2924C4.70185 12.9643 2.66606 10.7201 2.66606 8.00032V6.66699H3.99939V8.00032C3.99939 10.2095 5.79025 12.0003 7.99939 12.0003C8.86328 12.0003 9.66321 11.7265 10.3171 11.2608L9.35404 10.2978C8.95704 10.5324 8.49394 10.667 7.9994 10.667C6.52664 10.667 5.33273 9.47308 5.33273 8.00033V6.27646ZM8.34476 9.2885C8.23461 9.31796 8.11883 9.33366 7.99939 9.33366C7.26301 9.33366 6.66606 8.73671 6.66606 8.00033V7.60979L8.34476 9.2885ZM9.33272 3.33366V6.52419L10.6661 7.85753V3.33366C10.6661 1.8609 9.47216 0.666992 7.9994 0.666992C6.7736 0.666992 5.74098 1.49406 5.42913 2.6206L6.66606 3.85753V3.33366C6.66606 2.59728 7.26301 2.00033 7.99939 2.00033C8.73577 2.00033 9.33272 2.59728 9.33272 3.33366ZM12.905 10.0965L11.8599 9.05135C11.9508 8.71643 11.9994 8.36405 11.9994 8.00032V6.66699H13.3327V8.00032C13.3327 8.74448 13.1803 9.45304 12.905 10.0965Z",
    fill: "#F5F5FB"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/micOff.214bf664.svg";
export { ForwardRef as ReactComponent };